import { ScrollView } from "@opencode/ui/scroll-view"
import { createHomeController } from "./model"
import { createHomeProjectsController } from "./projects/controller"
import { HomeProjects } from "./projects/region"
import { createHomeScrollController } from "./scroll"
import { createHomeSessionSearchController } from "./sessions/search"
import { createHomeSessionsController } from "./sessions/controller"
import { HomeSessions } from "./sessions/region"
import "./home.css"

export function Home() {
  const home = createHomeController()
  const projects = createHomeProjectsController(home)
  const sessions = createHomeSessionsController(home)
  const search = createHomeSessionSearchController(home, sessions)
  const scroll = createHomeScrollController(sessions.data.groups)
  return (
    <div class="sair-home">
      <header class="sair-home-header">
        <h1 class="sr-only">{projects.copy.language.t("session.navigation.library")}</h1>
        <div class="sair-home-projects">
          <span class="sair-home-section-label">{projects.copy.language.t("home.projects")}</span>
          <HomeProjects projects={projects} scroll={scroll} dropdown />
        </div>
      </header>
      <ScrollView
        class="sair-home-scroll min-h-0 flex-1 [container-type:size]"
        thumbContainer={scroll.viewport.thumbTrack()}
        thumbHoverTarget={scroll.viewport.hoverTarget()}
        viewportRef={scroll.viewport.setViewport}
        onScroll={(event) => scroll.viewport.update(event.currentTarget.scrollTop)}
        onWheel={scroll.viewport.containOuterWheel}
      >
        <div class="sair-home-sessions">
          <HomeSessions sessions={sessions} search={search} scroll={scroll} />
        </div>
      </ScrollView>
    </div>
  )
}
